'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var slideOutDown = {
  from: {
    transform: (0, _utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, _utils.translate3d)(0, '100%', 0)
  }
};
exports.default = slideOutDown;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/slide-out-down.js
// module id = 797
// module chunks = 0